const MOBILE_DEBUG_QUERY = 'flcMobileDebug';
const MOBILE_DEBUG_STORAGE = 'flcMobileDebugPlatform';

const normalizePlatform = value => {
  const platform = String(value || '').trim().toLowerCase();
  return platform === 'ios' || platform === 'android' ? platform : '';
};

const getBrowserDebugPlatform = () => {
  if (typeof window === 'undefined') return '';

  try {
    const params = new URLSearchParams(window.location.search || '');
    if (params.has(MOBILE_DEBUG_QUERY)) {
      const raw = String(params.get(MOBILE_DEBUG_QUERY) || '').trim().toLowerCase();
      if (raw === 'off' || raw === '0' || raw === 'false' || raw === 'web') {
        window.sessionStorage.removeItem(MOBILE_DEBUG_STORAGE);
        return '';
      }

      const platform = normalizePlatform(raw);
      if (platform) {
        window.sessionStorage.setItem(MOBILE_DEBUG_STORAGE, platform);
        return platform;
      }
    }

    return normalizePlatform(window.sessionStorage.getItem(MOBILE_DEBUG_STORAGE));
  } catch (error) {
    return '';
  }
};

export const getMobileAppPlatform = () => {
  if (typeof window === 'undefined') return 'web';

  const capacitor = window.Capacitor;
  if (capacitor) {
    if (typeof capacitor.getPlatform === 'function') {
      const platform = String(capacitor.getPlatform() || '').toLowerCase();
      if (platform === 'ios' || platform === 'android') return platform;
    }

    if (typeof capacitor.isNativePlatform === 'function' && capacitor.isNativePlatform()) {
      return 'native';
    }
  }

  // Browser-only QA switch. This lets DevTools exercise the exact mobile
  // presentation/runtime branches without changing production desktop behavior.
  const debugPlatform = getBrowserDebugPlatform();
  if (debugPlatform) return debugPlatform;

  return 'web';
};

export default () => {
  const platform = getMobileAppPlatform();
  return platform === 'ios' || platform === 'android' || platform === 'native';
};
